import React from 'react';
import { X, Edit3, CheckSquare } from 'lucide-react';

interface BulkActionToolbarProps {
  selectedCount: number;
  onEditDrivers: () => void;
  onClearSelection: () => void;
  onSelectAllRevenue?: () => void;
  onSelectAllExpense?: () => void;
  isLoading?: boolean;
}

export function BulkActionToolbar({
  selectedCount,
  onEditDrivers,
  onClearSelection,
  onSelectAllRevenue,
  onSelectAllExpense,
  isLoading = false,
}: BulkActionToolbarProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-slate-900 text-white rounded-xl shadow-xl px-4 py-3 flex items-center gap-4">
        {/* Selection count */}
        <div className="flex items-center gap-2 pr-4 border-r border-slate-700">
          <CheckSquare size={18} style={{ color: 'var(--lodge-orange-400)' }} />
          <span className="font-medium">{selectedCount} selected</span>
        </div>

        {/* Quick select buttons */}
        <div className="flex items-center gap-2 pr-4 border-r border-slate-700">
          {onSelectAllRevenue && (
            <button
              onClick={onSelectAllRevenue}
              className="px-3 py-1.5 text-sm text-slate-300 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
            >
              All Revenue
            </button>
          )}
          {onSelectAllExpense && (
            <button
              onClick={onSelectAllExpense}
              className="px-3 py-1.5 text-sm text-slate-300 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
            >
              All Expense
            </button>
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            onClick={onEditDrivers}
            disabled={isLoading}
            className="flex items-center gap-2 px-4 py-1.5 rounded-lg transition-all font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ background: 'var(--lodge-orange-400)', color: '#ffffff', border: 'none', boxShadow: 'var(--shadow-orange)' }}
            onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--lodge-orange-500)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--lodge-orange-400)'; }}
          >
            <Edit3 size={16} />
            Edit Drivers
          </button>
          <button
            onClick={onClearSelection}
            disabled={isLoading}
            className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
            title="Clear selection"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkActionToolbar;
